<template>
  <div class="form form-grid">
    <h3 class="form-sec-title col--wide">Produto {{ props.index + 1 }}</h3>

    <DropdownInput class="col--wide col--md-5" required
    :label="_e('sac_produto_label')"
    :placeholder="_e('sac_produto_placeholder')"
    :options="produtoOptions"
    v-model="model.produto"></DropdownInput>

    <BaseInput class="col--wide col--md-4 col--new-row" required
    :label="_e('sac_lote_label')"
    :placeholder="_e('sac_lote_placeholder')"
    v-model="model.lote"></BaseInput>

    <BaseInput class="col--wide col--md-4" required
    :label="_e('sac_peso_label')"
    :placeholder="_e('sac_peso_placeholder')"
    v-model="model.peso"></BaseInput>

    <BaseInput class="col--wide col--md-4" required
    :label="_e('sac_data_label')"
    :placeholder="_e('sac_data_placeholder')"
    mask="##/##/####"
    v-model="model.data"></BaseInput>

    <BaseInput class="col--wide" required
    :label="_e('sac_local_label')"
    :placeholder="_e('sac_local_placeholder')"
    v-model="model.local"></BaseInput>

    <TextareaInput class="col--wide" required
    :label="_e('sac_desc_label')"
    :placeholder="_e('sac_desc_placeholder')"
    v-model="model.desc"></TextareaInput>

    <FileInput class="col--wide col--md-6"
    :label="_e('sac_midia_label')"
    :placeholder="_e('sac_midia_placeholder')"
    v-model="model.midia"></FileInput>

    <hr>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { _e } from '../../../helpers/l10n';
import { useSacStore, getProdutoNovo } from '../../../store/SacStore';

import DropdownInput from '../../form/inputs/DropdownInput.vue';
import BaseInput from '../../form/inputs/BaseInput.vue';
import TextareaInput from '../../form/inputs/TextareaInput.vue';
import FileInput from '../../form/inputs/FileInput.vue';

const props = defineProps({
  index: {
    type: Number,
    default : 0
  }
});

const produtoOptions = _e('sac_produtos_list');
const isProductEditing = ref(true);
const isNewProduct = ref(true);

const sacStore = useSacStore();

const model = defineModel({
  type: Object,
  default: () => (getProdutoNovo()),
});
</script>
